module.exports = __webpack_public_path__ + "static/media/whatsapp.c9483442.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/GuruProfile/whatsapp.svg
// module id = 2579
// module chunks = 0